import { isServer } from "@iso/lib/helpers/isServer";

const productDatas = [];  // Assuming this is populated with actual data somewhere in your code

function getInitData() {
  let productQuantity = [];
  const products = {};

  // Use localStorage to get mallType. Ensure it exists before proceeding.
  const mallType = localStorage.getItem("mallType");


  if (!isServer) {
    const cartProductQuantity = localStorage.getItem("cartProductQuantity");
    let cartProducts = localStorage.getItem("cartProducts");

    if (cartProducts && cartProductQuantity) {
      cartProducts = JSON.parse(cartProducts);
      JSON.parse(cartProductQuantity).forEach((product) => {
        const productCode = product.productCode;

        // Check that the product quantity is a valid number
        if (!isNaN(product.quantity)) {
          productQuantity.push({
            productCode,
            quantity: parseInt(product.quantity, 10),
          });

          // Add product details
          products[productCode] = {
            ...cartProducts[productCode],
            price: parseFloat(cartProducts[productCode].memberPrice, 10),
          };
        }
      });
    } else {
      // If no cart products, fallback to productDatas
      productDatas.forEach((product) => {
        productQuantity.push({
          productCode: product.productCode,
          quantity: 1,  // Default quantity if no cart data exists
        });
        products[product.productCode] = product;
      });
    }
  }

  return { productQuantity, products, mallType };
}

export default getInitData();
